import Head from "next/head";
import { Container, Typography, Grid, Link } from "@mui/material";

import { useTranslation } from "../fe-ui/hooks/use-translation";

import MainLayout from "../ui/layouts/main";
import ContactMap from "../ui/components/contact/ContactMap/ContactMap";

import { ReactElement } from "react";
import { composeServerSideProps } from "next-composition";
import { withTranslations } from "../server/ssrprops/withTranslations";
import { withSeoSsrProps } from "../server/ssrprops/withSeoSsrProps";

const ContactUsPage = () => {
  const t = useTranslation();

  return (
    <>
      <Head>
        <title>{t("ContactUs_feelFreeToContactUs")}</title>
      </Head>
      <Container maxWidth={"lg"}>
        <Typography variant="h1" component="h1" sx={{ mt: 4, mb: 10 }}>
          {t("Footer_contacts")}
        </Typography>
        <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ pb: 5 }}>
          <Grid item xs={12} sm={6} md={4}>
            <Link variant="bodyXl" href="mailto:reception@seaya.az" sx={{ pb: 0.5 }}>
              {"reception@seaya.az"}
            </Link>
            <Typography variant="body1">{t("ContactUs_booking")}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Link variant="bodyXl" href="mailto:sales@seaya.az" sx={{ pb: 0.5 }}>
              {"sales@seaya.az"}
            </Link>
            <Typography variant="body1">{t("ContactUs_cooperation")}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Link variant="bodyXl" href="mailto:support@seaya.az" sx={{ pb: 0.5 }}>
              {"support@seaya.az"}
            </Link>
            <Typography variant="body1">{t("ContactUs_anyQuestion")}</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={{ xs: 3, sm: 4 }} sx={{ mb: 10 }}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              {t("ContactUs_office")}
            </Typography>
            <Typography variant="bodyLg" component="p" sx={{ mb: 3 }}>
              {t("ContactUs_address1")}
            </Typography>
            <ContactMap officeType="base" />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              {t("ContactUs_officeBreeze")}
            </Typography>
            <Typography variant="bodyLg" component="p" sx={{ mb: 3 }}>
              {t("ContactUs_address2")}
            </Typography>
            <ContactMap officeType="seabreeze" />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              {t("ContactUs_office_sbtours")}
            </Typography>
            <Typography variant="bodyLg" component="p" sx={{ mb: 3 }}>
              {t("ContactUs_address_sbtours")}
              <br />
              <Link href="tel:+74996536560">{"+7 (499) 653-6560"}</Link>
              <br />
              <Link href="mailto:privet@sbtours.ru">{"privet@sbtours.ru"}</Link>
            </Typography>
            <ContactMap officeType="sbtours" />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const ContactUsPageWrapper = () => {
  return <ContactUsPage />;
};

export default ContactUsPageWrapper;

ContactUsPageWrapper.getLayout = (page: ReactElement) => <MainLayout> {page} </MainLayout>;

export const getServerSideProps = composeServerSideProps({
  use: [withTranslations, withSeoSsrProps],
});
